import ProfileEntryPage from './pages/profile-entry/components/ProfileEntryPage';

const onboardingRoute = {
  path: 'onboarding',

  indexRoute: {
    onEnter: (nextState, replace) => replace('onboarding/profile')
  },

  component: props => props.children,

  childRoutes: [
    {
      path: 'profile',
      component: ProfileEntryPage
    }
  ]
};

export default onboardingRoute;



// WEBPACK FOOTER //
// ./src/client/plugins/onboarding/index.js